import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'reactstrap';

import questionBankIcon from '../../assets/img/question_bank/question_icon_blue.svg';
import ComponentHeader from '../../common/ComponentHeader';
import CustomButton from '../../common/CustomButton';
import { renderHTMLContent, isRevisionModeActive, countStatements } from '../../common/function';
import { messages } from '../../common/messages';
import FlashCard from '../../components/FlashCard';
import appRoutes from '../../routes/exams/gmat-focus/app-routes';
import ValidateSaveReportIcon from '../../views/Common/ValidateSaveReportIcon';
import AppRoutes from '../../views/config/AppRoutes';
import CustomCard from '../QuestionBank/CustomCard';
import CustomCardBody from '../QuestionBank/CustomCardBody';
import CustomCardHeader from '../QuestionBank/CustomCardHeader';
import LoaderWrapper from '../QuestionBank/LoaderWrapper';
import ReportComponent from '../ReportComponent';
import GMATCalculator from '../../common/Calculator/GMATCalculator';
import { EXAM_NAMES, examNames, QUESTION_TYPE, SUBSCRIPTION_STATUS } from '../../common/constant';
import { getUserSelectedChoices } from './utils/questionUtils';
import { multiSourceConfig } from './utils/questionConfigs';
import RatingComponent from '../RatingComponent';

export default class MultiSourceTab extends Component {
  static contextTypes = {
    router: PropTypes.object,
  };
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      isUserSubscribed: false,
      currentIndex: 0,
      currentQuestion: {},
      questionData: [],
      selectedAnswer1: '',
      selectedAnswer2: '',
      validated: false,
      isUserSelectedChoice: false,
      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
      saveTooltipTitle: `${messages.SAVE_ITEM_DESCRIPTION}`,
      questionRatingTitle: messages.RATING_THIS_QUESTION,
      isFlashCardHidden: true,
      isReportCardHidden: true,
      showCalculator: false,
      isError: false,
    };
    this.childRef = null;
    this.setChildRef = (element) => {
      this.childRef = element;
    };
    const { questionMode = EXAM_NAMES.GMAT_FOCUS } = this.props;
    this.isRevisionMode = isRevisionModeActive(questionMode);
  }
  async componentDidMount() {
    const {
      apiServices,
      params,
      questionType: question_type,
    } = this.props;
    const { readingid, subscription } = params;
    const payload = {
      reading_id: readingid,
      question_type,
      subscriptionstatus: +subscription ? SUBSCRIPTION_STATUS.PAID : SUBSCRIPTION_STATUS.FREE,
    };

    const response = await apiServices.fetchQuestionsReadingWise(payload);
    if (!response.success) return;

    let questions = response.result || [];

    const isSubscribed = !!+subscription;
    if (!isSubscribed) {
      questions = questions.filter((question) => +question.free === 1);
    }

    await this.handleSetCurrentQuestion(questions);
    this.setState({
      questionData: questions,
      isUserSubscribed: isSubscribed,
      isLoading: false,
    });
  }
  setUserSelectedChoices = (index, questions) => {
    const questionData = questions || this.state.questionData;
    const currentQuestion = questionData[index];
    const { stateTableName = 'gmat_focus_question_stat' } = this.props;
    const attemptedStateDetails = (currentQuestion && currentQuestion[stateTableName]) || {};

    const { selectedOptions, extraState } = getUserSelectedChoices({
      question: currentQuestion,
      stat: attemptedStateDetails,
      config: multiSourceConfig,
    });
    if (selectedOptions && Object.keys(selectedOptions).length > 0) {
      this.setState({ ...extraState, selectedOptions }, () => {
        this.handleValidate(false);
      });
    } else {
      this.setState({ ...extraState, selectedOptions });
    }
  };

  handleSetCurrentQuestion = async (questions) => {
    this.setState({ isLoading: true });
    const { question_id: questionId } = this.props.params;
    const index = questions.findIndex((question) => question.id === +questionId) || 0;

    this.setState({
      currentIndex: index > -1 ? index : 0,
      currentQuestion: questions[index > -1 ? index : 0],
      isLoading: false,
    });
    this.getSavedQuestion(questions[index > -1 ? index : 0].id);
    this.getQuestionRating(questions[index > -1 ? index : 0].id);
    if (this.isRevisionMode) {
      this.setUserSelectedChoices(index, questions);
    } else {
      this.resetStates();
    }
  };

  handleSaveQuestion = async () => {
    const { questionId, reading, bookmarkCSS } = this.state;
    const {
      apiServices,
      questionType: type,
      params: { readingid: reading_id, question_id, reading: topic_name },
    } = this.props;

    const isSaved = bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark';

    const payload = {
      question_id,
      type,
      topic_name,
      reading_id,
    };

    const endpoint = isSaved ? apiServices.deleteSavedQuestion : apiServices.saveQuestion;
    const response = await endpoint(payload);

    if (isSaved && this.childRef) {
      this.childRef.deleteFlash();
    }

    this.setState({
      bookmarkCSS: isSaved
        ? 'fa fa-bookmark-o mark-action-btn-bookmark'
        : 'fa fa-bookmark mark-action-btn-bookmark',
      bookmarkColor: isSaved ? '' : 'rgb(54, 141, 84)',
      saveTooltipTitle: isSaved ? messages.SAVE_ITEM_DESCRIPTION : messages.QUESTION_SAVED,
      isFlashCardHidden: isSaved,
    });
  };

  getSavedQuestion = async (questionId) => {
    const { apiServices, params, questionType: type } = this.props;
    const { chapterid: chapter_id } = params;

    const payload = {
      question_id: questionId,
      chapter_id,
      type,
    };
    const response = await apiServices.fetchSavedQuestion(payload);
    this.setState({
      isFlashCardHidden: !response.success,
      ...(response.success && {
        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
        bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
        bookmarkColor: 'rgb(54, 141, 84)',
        saveTooltipTitle: `${messages.QUESTION_SAVED}`,
        isFlashCardHidden: false,
      }),
    });
  };

  getQuestionRating = async (question_id) => {
    const { apiServices, questionType: type } = this.props;
    const params = {
      question_id,
      type,
    };

    try {
      const response = await apiServices.fetchRating(params);

      const { success, ratting } = response;
      if (success && ratting && ratting.length > 0) {
        //TODO Change the API and fetch rating in object not array
        const questionRating = response.ratting[0].ratting;

        this.setState({
          questionRating,
          questionRatingTitle: messages.RATED,
        });
      }
    } catch (error) {
      // Error handling intentionally left blank to avoid console logs
    }
  };

  handleQuestionRating = async (item, nextValue, prevValue, name) => {
    const { questionId } = this.state;
    const question_id = item.id;
    const { apiServices, questionType: type } = this.props;

    try {
      // Only update if the rating changed
      if (prevValue !== nextValue) {
        const updatePayload = { question_id, ratting: nextValue, type };
        const updateRatingResponse = await apiServices.updateQuestionRating(updatePayload);

        if (updateRatingResponse.success) {
          this.setState({ questionRatingTitle: messages.RATED });
        }
      }

      this.setState({ rating: nextValue });

      // Check if a rating already exists
      const fetchPayload = { question_id, type };
      const response = await apiServices.fetchRating(fetchPayload);

      const { success, ratting } = response;
      if (success && ratting && ratting.length > 0) {
        //TODO Change the API and fetch rating in object not array
        const latestRating = response.ratting[0].ratting;
        this.setState({
          questionRating: latestRating,
          questionRatingTitle: `${messages.RATED}`,
        });
      } else {
        // Save a new rating
        const savePayload = {
          question_id,
          ratting: nextValue,
          type,
        };
        const saveResponseRating = await apiServices.saveRating(savePayload);

        if (saveResponseRating.success) {
          this.setState({
            questionRatingTitle: messages.RATED,
            questionRating: nextValue,
          });
        }
      }
    } catch (error) {
      // Error handling intentionally left blank to avoid console logs
    }
  };

  resetStates = () => {
    this.setState({
      validated: false,
      selectedAnswer1: '',
      isError: false,
      questionRating: 0,
      selectedAnswer2: '',
      selectedOptions: {},
      isUserSelectedChoice: false,
      isReportCardHidden: true,
      isFlashCardHidden: true,
      questionRatingTitle: messages.RATING_THIS_QUESTION,
      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
      bookmarkColor: '',
      saveTooltipTitle: `${messages.SAVE_ITEM_DESCRIPTION}`,
    });
  };

  redirectToNextPreviousQuestion = (index) => {
    const { questionData, isUserSubscribed } = this.state;
    const { handleChangeParams, params } = this.props;
    const { readingid, chapterid } = params;
    const currentQuestion = questionData[index];

    if (!currentQuestion) return;

    const { id } = currentQuestion;
    handleChangeParams({ index, question_id: id });
    this.setState({
      currentIndex: index,
      currentQuestion,
    });

    this.getSavedQuestion(id);
    this.getQuestionRating(id);
  };

  getPreviousQuestion = async () => {
    const { currentIndex } = this.state;
    if (currentIndex > 0) {
      this.redirectToNextPreviousQuestion(currentIndex - 1);
      this.resetStates();
      if (this.isRevisionMode) this.setUserSelectedChoices(currentIndex - 1);
    }
  };

  getNextQuestion = async () => {
    const { currentIndex, questionData } = this.state;
    const nextIndex = currentIndex + 1;
    if (nextIndex < questionData.length) {
      this.redirectToNextPreviousQuestion(nextIndex);
      this.resetStates();
      if (this.isRevisionMode) this.setUserSelectedChoices(nextIndex);
    }
  };

  handleSelect = (type, value) => {
    this.setState({ [type]: value });
  };

  handleValidate = async (isSaveAttemptStats = true) => {
    const { selectedOptions = {}, currentQuestion } = this.state;
    const { apiServices, questionType: type } = this.props;
    // Count how many statements exist in this question
    const totalStatements = countStatements(currentQuestion);

    const selectedCount = Object.values(selectedOptions).filter(Boolean).length;
    // We cannot remove the `is_single_choice` condition because validation rules differ:
    // - For single choice questions → the user must select exactly ONE option.
    // - For multi-statement questions → the user must provide an answer for EACH available statement.
    // Without this condition, both question types would be validated the same way, which would break correctness.
    const isValidated = currentQuestion.is_single_choice ? selectedCount === 1 : selectedCount  === totalStatements;
    if (!isValidated) {
      this.setState({ isError: true });
      return;
    }

    // Reverse: check every selectedOption key exists in currentQuestion and matches the correct answer
    const isCorrect = Object.keys(selectedOptions).every((key) => {
      if (currentQuestion[key] !== undefined && currentQuestion[key] !== null) {
        return String(currentQuestion[key]).trim() === String(selectedOptions[key] || '').trim();
      }
      return false;
    });
    const selectedChoice = JSON.stringify(selectedOptions);

    this.setState((prevState) => ({
      validated: true,
      isUserSelectedChoice: isCorrect,
    }));
    const payload = {
      question_id: currentQuestion.id,
      right_answer: isCorrect,
      selected_choice: selectedChoice,
      type,
    };
    if (isSaveAttemptStats) {
      await apiServices.saveAttemptStats(payload);
      const { stateTableName = 'gmat_focus_question_stat' } = this.props;

      this.setState({
        questionData: this.state.questionData.map((questionDetails) =>
          questionDetails.id === currentQuestion.id
            ? {
                ...questionDetails,
                [stateTableName]: {
                  selected_choice: selectedChoice,
                  isSelectedChoice: isCorrect,
                },
              }
            : questionDetails,
        ),
      });
    }
  };

  handleChoicesSelect = (event) => {
    const { name, value } = event.target;
    const { currentQuestion } = this.state;

    this.setState((prevState) => {
      let selectedOptions;
      if (currentQuestion.is_single_choice) {
        // Only keep the current selection for single choice
        selectedOptions = { [name]: value };
      } else {
        // Keep previous selections for multi choice
        selectedOptions = {
          ...prevState.selectedOptions,
          [name]: value,
        };
      }
      return {
        selectedOptions,
        isError: false,
      };
    });
  };
  renderOptions = () => {
    const { validated, currentQuestion, selectedOptions = {} } = this.state;

    // Get entries like { key: "statement1", value: "Some statement" }
    const optionEntries = Object.entries(currentQuestion)
      .filter(([key]) => key.startsWith('statement'))
      .map(([key, value]) => ({ key, value }));

    return optionEntries.map((optionValue, index) => {
      const optionKey = optionValue.key; // e.g., "statement1"
      const answerKey = optionKey.replace('statement', 'answer'); // e.g., "answer1"
      const correctAnswer = currentQuestion[answerKey]; // e.g., "yes" or "no"
      const choicesStatement = currentQuestion.is_single_choice ? ['yes'] : ['yes', 'no'];
      return (
        optionValue.value && (
          <tr key={optionKey}>
            {choicesStatement.map((choiceValue) => {
              const isSelectedChoice = selectedOptions[answerKey] === choiceValue;

              // Apply validation class if validated is true and choice is selected
              let validationClass = '';
              const isCorrect = String(choiceValue).trim() === String(correctAnswer).trim();
              if (validated && isSelectedChoice) {
                validationClass = isCorrect ? 'accent-success' : 'accent-faliure';
              }
              const isShowCorrectChoices = validated && !isSelectedChoice && isCorrect;
              const ariaLabel = `${choiceValue} — ${optionValue.value}`;
              return (
                <td className={`p-10px ${validationClass}`} key={`${answerKey}-${choiceValue}`}>
                  {isShowCorrectChoices ? (
                    <input
                      type='radio'
                      name={`correct${index}`}
                      aria-label={`Correct answer: ${ariaLabel}`}
                      className='accent-success'
                      checked
                      readOnly
                    />
                  ) : (
                    <input
                      type='radio'
                      name={answerKey}
                      aria-label={ariaLabel}
                      className='border-solid'
                      checked={isSelectedChoice}
                      value={choiceValue}
                      disabled={!validationClass && validated}
                      onChange={this.handleChoicesSelect}
                    />
                  )}
                </td>
              );
            })}
            <td className='p-10px text-left'>{optionValue.value}</td>
          </tr>
        )
      );
    });
  };

  reportCardToggle = () => {
    this.setState((prevState) => ({
      isReportCardHidden: !prevState.isReportCardHidden,
    }));
  };

  /**
   * Handles tab change events by updating the display of tab content and the active state of tab links.
   * This function is used as-is from older code and has not been modified.
   */
  onHandleTabChange = (event, tabName) => {
    const tabContent = document.getElementsByClassName('tabcontent');
    const tabLinks = document.getElementsByClassName('tablinks');
    const value = event.target.value;
    for (let i = 0; i < tabContent.length; i++) {
      tabContent[i].style.display = 'none';
    }
    for (let i = 0; i < tabLinks.length; i++) {
      if (tabLinks[i].value === tabName) {
        tabLinks[i].className += ' active';
      } else {
        tabLinks[i].classList.remove('active');
      }
    }
    document.getElementById(tabName).style.display = 'block';
  };

  clickHandler = (event) => {
    this.onHandleTabChange(event, event.target.value.trim());
  };

  render() {
    const {
      isLoading,
      questionData,
      currentIndex,
      currentQuestion,
      isUserSelectedChoice,
      validated,
      saveTooltipTitle,
      bookmarkCSS,
      bookmarkColor,
      isFlashCardHidden,
      isReportCardHidden,
      questionRating,
      questionRatingTitle,
      showCalculator,
      isError,
    } = this.state;
    const { apiServices, params, redirectTo, questionType, examName } = this.props;

    // URL params expose `:readingid` (lowercase) and `:reading`; rename to the
    // snake_case keys that the BE /reportQuestion writer expects. Sending
    // `readingId` causes req.body.reading_id to be undefined → NULL in
    // ea_ques_reports / gmat_focus_ques_reports → admin /reports URLs land
    // on /update/null/null/null/null/question and 400 out.
    const { readingid: reading_id, question_id, type, reading: topic_name } = params;
    const { id, question_tab, question, is_single_choice, choice_a, choice_b, explanation } =
      currentQuestion;
    return (
      <div>
        <ComponentHeader title={messages.QUESTION_BANK}>
          <div>
            <CustomButton
              className='mr-1 calc-btn'
              onClick={() =>
                this.setState({
                  showCalculator: true,
                })
              }
            >
              {messages.OPEN_CALCULATOR}
            </CustomButton>
            <CustomButton className='mr-1' onClick={() => redirectTo('question')}>
              {messages.CHANGE_QUESTION}
            </CustomButton>
            <CustomButton onClick={() => redirectTo('reading')}>
              {messages.CHANGE_READING}
            </CustomButton>
          </div>
        </ComponentHeader>

        <LoaderWrapper isLoading={isLoading}>
          {currentQuestion && Object.keys(currentQuestion).length ? (
            <CustomCard>
              <CustomCardHeader
                headingText={`${topic_name} (Q. ${id})`}
                headerImage={questionBankIcon}
                arrayLength={questionData.length}
                showPreviousButton
                showNextButton
                disabledPreviousButton={currentIndex < 1}
                disabledNextButton={currentIndex >= questionData.length - 1}
                getPreviousQuestion={this.getPreviousQuestion}
                getNextQuestion={this.getNextQuestion}
              />
              <CustomCardBody>
                <Row>
                  <div className='col-lg-6 mb-0 calc_height_GMAT overflow-y-auto mb-sm-1 question-view'>
                    {renderHTMLContent(question_tab, 'div', '', {
                      onClick: this.clickHandler,
                    })}
                  </div>
                  <Col xs={6} sm={12} lg={6} className='text-center font-16px'>
                    {renderHTMLContent(question, 'div', 'text-left')}
                    <table className='text-center  margin_bottom_30 mt-3'>
                      {!is_single_choice && (
                        <thead>
                          <tr>
                            <th className='p-10px'>{choice_a}</th>
                            <th className='p-10px'>{choice_b}</th>
                            <th className='p-10px' />
                          </tr>
                        </thead>
                      )}
                      <tbody>{this.renderOptions()}</tbody>
                    </table>

                    <Row>
                      {isError && (
                        <Col sm={12} md={12} lg={12} className='text-danger text-left  mb-0 pb-0'>
                          {messages.SELECT_OPTION_ERROR}
                        </Col>
                      )}
                      <Col xs={6} lg={6} sm={6} className='text-center mt-3 d-flex'>
                        {/* // TODO: Optimize this code in the future and remove the CSS states from component state */}
                        <ValidateSaveReportIcon
                          isQue={true}
                          showResult={validated}
                          _getResult={this.handleValidate}
                          _saveQuestion={this.handleSaveQuestion}
                          _displayReportForm={this.reportCardToggle}
                          all_questions={questionData}
                          save_text={saveTooltipTitle}
                          bookmarkCSS={bookmarkCSS}
                          bookmarkColor={bookmarkColor}
                        />
                      </Col>
                      <Col
                        xs={6}
                        lg={6}
                        sm={6}
                        className='text-center mt-3 d-flex align-items-center justify-content-end'
                      >
                        <span className='margin_bottom_0 margin_right_10'>
                          {questionRatingTitle}:
                        </span>
                        <RatingComponent
                          rating={questionRating}
                          onChange={(nextValue, prevValue, name) =>
                            this.handleQuestionRating(currentQuestion, nextValue, prevValue, name)
                          }
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </CustomCardBody>
            </CustomCard>
          ) : (
            <h1 className='text-center pt-3 pb-3'>{messages.NO_DATA_FOUND}</h1>
          )}
        </LoaderWrapper>

        {validated && (
          <Row>
            <Col>
              <CustomCard className='font-lusitana font-16px'>
                <CustomCardHeader
                  headingText={isUserSelectedChoice ? messages.CORRECT : messages.INCORRECT}
                  className={`text-uppercase ${isUserSelectedChoice ? 'text_success' : 'text_failure'}`}
                />
                <CustomCardBody>{renderHTMLContent(explanation, 'span')}</CustomCardBody>
              </CustomCard>
            </Col>
          </Row>
        )}
        <FlashCard
          item={{ id: currentQuestion && id }}
          type={QUESTION_TYPE.QUESTION}
          question_type={questionType}
          isFlashCardHidden={isFlashCardHidden}
          ref={this.setChildRef}
          exam={examName}
        />
        {/* //TODO: Remove the !from the common component */}
        <ReportComponent
          visible={!isReportCardHidden}
          apiServices={apiServices}
          payload={{
            question_id,
            type,
            topic_name,
            reading_id,
          }}
        />
        <GMATCalculator
          show={showCalculator}
          closeModal={() => this.setState({ showCalculator: false })}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components-2025/IR/MultiSourceTab.jsx